<template>
    <div class="d-flex justify-content-center pt-5">
        <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>